// 全局过滤
import Vue from 'vue'
import dayjs from 'dayjs'

// 格式化金额
Vue.filter('money', (val) => {
  return `¥${Number(val).toFixed(2)}`
})
// 格式化金额 无小数点
Vue.filter('moneyNoPoint', (val) => {
  return `¥${Number(val)}`
})
// 千位分割符
Vue.filter('thousandBitSeparator', (val) => {
  return val && val.toString()
    .replace(/\d+/, function (s) {
      return s.replace(/(\d)(?=(\d{3})+$)/g, '$1,')
    })
})
// 格式化日期
Vue.filter('formatDate', (val) => {
  return val && dayjs(val).format('YYYY-MM-DD HH:mm:ss')
})
Vue.filter('formatDate4HHmm', (val) => {
  return val && dayjs(val).format('HH:mm')
})
Vue.filter('formatDateYMDHM', (val) => {
  return val && dayjs(val).format('YYYY-MM-DD HH:mm')
})
Vue.filter('formatDateYMD', (val) => {
  return val && dayjs(val).format('YYYY-MM-DD')
})
Vue.filter('formatDateMD', (val) => {
  return val && dayjs(val).format('MM-DD')
})
Vue.filter('formatDateMDCN', val => {
  return val && dayjs(val).format('MM月DD日')
})
Vue.filter('formatDate4Day', (val) => {
  const chinaWeeks = ['日', '一', '二', '三', '四', '五', '六', '日']
  return chinaWeeks[dayjs(val).day()]
})
Vue.filter('passengerTypeFmt', (val) => {
  return {
    'ADT': '成人',
    'CHD': '儿童'
  }[val]
})
// 格式化毫秒数为 时 分
Vue.filter('formatTimeStr', val => {
  let h = parseInt((val % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
  let sen = parseInt((val % (1000 * 60 * 60)) / (1000 * 60))
  let str = ''
  h && (str += `${h}小时`)
  sen && (str += `${sen}分`)
  return str
})
Vue.filter('discount', (val) => {
  return (isNaN(val) ? '--' : (val ? `${Number(val * 100).toFixed(2)}%` : `${val}%`))
})
Vue.filter('changeHM', str => {
  let s = ''
  let arr = (str || '').split(':');
  (+arr[0]) && (s += `${arr[0]}小时`);
  (+arr[1]) && (s += `${arr[1]}分`)
  return s
})



// WEBPACK FOOTER //
// ./src/utils/globalFilter.js